import {CaretRightOutlined} from '@ant-design/icons';
import {Flex, Progress, Image} from 'antd';
import {useState} from 'react';
import {Employee, Props} from "../../models";

const UniversalCollapse = ({data, paddingLeft = 0}: Props) => {
  const [openItems, setOpenItems] = useState<Record<number, boolean>>({});

  const toggleItem = (key: number) => {
    setOpenItems((prev) => ({...prev, [key]: !prev[key]}));
  };

  const colors = (percent: number) => {
    if (percent >= 95) return '#00b533';
    if (percent >= 80) return '#ff9900';
    return '#ff0000';
  }

  return (
      <>
        {data?.map((
                {
                  name, absenceCount,
                  disciplinePercent, earlyLeaveCount,
                  lateArriveCount, overBreakCount,
                  employees, children,
                }, dataIndex,
            ) => (
                <div key={dataIndex}>
                  <Flex
                      className={`${openItems[dataIndex] && 'bg-white'} flex justify-center items-center cursor-pointer bg-gray-100 pl-3 hover:bg-gray-50`}
                      onClick={() => toggleItem(dataIndex)}
                  >
                    <div className="w-[250%] py-3">
                      <div style={{paddingLeft: paddingLeft + 'px'}}>
                        <CaretRightOutlined className={`${openItems[dataIndex] && 'rotate-90'} mr-4`}/>
                        {name}
                      </div>
                    </div>
                    <div className="w-full py-3 text-center flex justify-center items-center">
                      <Progress percent={disciplinePercent} status="active" strokeColor={colors(disciplinePercent)}/>
                    </div>
                    <p className="w-full py-3 text-center">{lateArriveCount}</p>
                    <p className="w-full py-3 text-center">{earlyLeaveCount}</p>
                    <p className="w-full py-3 text-center">{overBreakCount}</p>
                    <p className="w-full py-3 text-center">{absenceCount}</p>
                  </Flex>

                  <Flex vertical className={`${!openItems[dataIndex] && 'hidden'}`}>
                    {children && (<UniversalCollapse data={children} paddingLeft={paddingLeft + 20}/>)}

                    <p className="mt-8 ml-3 font-bold">{name} xodimlari</p>

                    <div className="mb-8">
                      {employees &&
                          employees.map(
                              (
                                  {
                                    user, disciplinePercent,
                                    lateArriveCount, earlyLeaveCount,
                                    overBreakCount, absenceCount,
                                  }: Employee,
                                  employeeIndex,
                              ) => (
                                  <Flex
                                      key={employeeIndex} style={{borderBottom: "1px solid #D1D5DB"}}
                                      className="cursor-pointer border-b border-b-gray-200 pl-3 hover:bg-gray-50"
                                  >
                                    <div className="flex justify-center items-center mr-4">
                                      <Image src={user?.photo} className="!w-12 !h-12 rounded-full object-contain"/>
                                    </div>
                                    <p className="w-[250%] py-3">{user.fio}</p>
                                    <div className="w-full py-3 text-center flex justify-center items-center">
                                      <Progress percent={disciplinePercent} status="active"
                                                strokeColor={colors(disciplinePercent)}/>
                                    </div>
                                    <p className="w-full py-3 text-center">{lateArriveCount}</p>
                                    <p className="w-full py-3 text-center">{earlyLeaveCount}</p>
                                    <p className="w-full py-3 text-center">{overBreakCount}</p>
                                    <p className="w-full py-3 text-center">{absenceCount}</p>
                                  </Flex>
                              ),
                          )}
                    </div>
                  </Flex>
                </div>
            ),
        )}
      </>
  );
};

export default UniversalCollapse;
